export default "__VITE_ASSET__BmAJvRzS__"